import Api from '@/services/Api'

export default {
    // ===== FORMULARIOS =====
    getAllFormularios() {
        return Api().get('reporteLiquidacion/formularios')
    },
    getFormularioById(id) {
        return Api().get('reporteLiquidacion/formularios/' + id)
    },
    createFormulario(info) {
        return Api().post('reporteLiquidacion/formularios', info)
    },
    updateFormulario(info) {
        return Api().put('reporteLiquidacion/formularios', info)
    },
    deleteFormulario(id) {
        return Api().delete('reporteLiquidacion/formularios/' + id)
    },

    // ===== GRUPOS =====
    getGruposByFormulario(formulario) {
        return Api().get('reporteLiquidacion/grupos?formulario=' + formulario)
    },
    createGrupo(info) {
        return Api().post('reporteLiquidacion/grupos', info)
    },
    updateGrupo(info) {
        return Api().put('reporteLiquidacion/grupos', info)
    },
    deleteGrupo(id) {
        return Api().delete('reporteLiquidacion/grupos/' + id)
    },

    // ===== FILAS =====
    getFilasByGrupo(formulario, grupo) {
        return Api().get(`reporteLiquidacion/filas?formulario=${formulario}&grupo=${grupo}`)
    },
    getFilasByFormulario(formulario) {
        return Api().get('reporteLiquidacion/filas/all?formulario=' + formulario)
    },
    createFila(info) {
        return Api().post('reporteLiquidacion/filas', info)
    },
    updateFila(info) {
        return Api().put('reporteLiquidacion/filas', info)
    },
    deleteFila(id) {
        return Api().delete('reporteLiquidacion/filas/' + id)
    },
    getCodigosByReporte(reporte) {
        return Api().get('reporteLiquidacion/codigos?reporte=' + reporte)
    },
    updateGrupoFila(info) {
        return Api().put('reporteLiquidacion/filas/grupo', info)
    },

}